module.exports = __webpack_public_path__ + "static/media/ac-chevron-up.664ab244.svg";